import type { AtlasDonnee } from '@/models/interfaces/map/AtlasCategory'

export const OTHER_DATA_CATEGORY_CODE = 'OTHER_COMMUNE_DATA'

export interface OtherCommuneDataResult {
  donnees: AtlasDonnee[]
}

/**
 * Dedicated adapter for the future commune-specific "AUTRES DONNEES" API.
 * Replace the placeholder return with the backend route once available.
 */
export class OtherCommuneDataService {
  static async getOtherDataByCommune(communeName: string): Promise<OtherCommuneDataResult> {
    void communeName
    return { donnees: [] }
  }
}
